/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */
import AbstractResourceModel from "../AbstractResourceModel";

export default class QuoteResourceModel extends AbstractResourceModel {
    static className = 'QuoteResourceModel';

    /**
     * Constructor
     * @param props
     */
    constructor(props) {
        super(props);
        this.state = {resourceName : 'Quote'};
    }

    /**
     * Submig coupon code
     *
     * @param params
     * @returns {promise|*|rules}
     */
    submitCouponCode(params) {
        let rules = this.getResourceOnline().submitCouponCode(params);
        return rules;
    }

}


// WEBPACK FOOTER //
// ./src/resource-model/quote/QuoteResourceModel.js